<template>
  <div id="boarding-card">
    <div class="container">
      <div class="check-tab">
        <CheckInTab :tabInit="tabInit"></CheckInTab>
      </div>
      <components v-bind:is="stepName" :stepData="stepData" @callback="nextStep"></components>
    </div>
  </div>
</template>
<script>
import CheckInTab from '@/components/checkin/checkInTab'
import Step1 from './components/step1'
import Step2 from './components/step2'
import './index'
export default {
  components: {
    CheckInTab,
    Step1,
    Step2
  },
  data () {
    return {
      tabInit: '2',
      stepName: 'step1',
      stepData: {}
    }
  },
  created () {
    if (window.idInfo) {
      this.nextStep(2, window.idInfo)
    }
  },
  methods: {
    nextStep (step, data) {
      this.stepName = 'step' + step
      if (data) {
        this.stepData = data
      }
    }
  }
}
</script>
